module.exports = __webpack_public_path__ + "static/media/companion-img-004.03b9563e.jpg";